import { db } from '@/main'
import localisation from "@/setup"
import { doc, updateDoc } from "firebase/firestore";
import helpers from '@/helpers.js'
import { serverTimestamp } from "firebase/firestore";

export default {
  name: 'customiser',
  components: {
  },
  props: [],
  data () {
    return {
      openTab: 1,
      logoPreview: null,
      imagekit: null,
      view: {
        changeLogo: false,
        confirmDelete: false
      }
    }
  },
  computed: {
    org () {
      return this.$store.getters.activeOrg
    },
    user () {
      return this.$store.getters.userData
    },
    possibleOverrides () {
      let x = [];
      if(!this.org) return []
      console.log('this.org.customisations.localeOverrides:', this.org.customisations.localeOverrides);
      
      for (const phrase in this.org.customisations.localeOverrides) {
        x.push({
          label: phrase,
          currentVal: this.org.customisations.localeOverrides[phrase]
        });
      }      
      return x.sort((a,b) => {
        if(a.label > b.label){
          return 1
        } else {
          return -1
        }
      })
    }
  },
  mounted () {
    console.log('customiser | this.org:', this.org);

    if(this.$route.query && this.$route.query.t){
      this.openTab = parseFloat(this.$route.query.t)
    }
    console.log("this.openTab:", this.openTab)

  },
  methods: {
    toggleTabs: function(tabNumber){
      this.openTab = tabNumber
      this.$router.push({query: {t: tabNumber}})
    },
    initLogoUpload () {
      console.log("init logo change")
      this.$refs.logoUploader.childNodes[0].click()
    },
    onError (err) {
      console.log("err:", err)
      this.$toast.error(`Something went wrong caving your new logo`)
    },
    async onSuccess (res) {
      console.log("success:", res)
      
      // set res.url as the org logo.logo.transparent
      try {

        await this.udpateOrgData("logo.basic",res.filePath+'?cb='+new Date().getTime() )

        this.$toast.success(`Logo updated!`)

      } catch (error) {
        console.log('err saving org:', error)
        this.$toast.error(`Something went wrong updating your logo`)
      }
    },
    async udpateOrgData(key, value) {
      return new Promise(async(resolve, reject) => {

        try {
          let ref = doc(db, "orgs", this.org.id).withConverter(helpers.orgConverter)
          await updateDoc(ref, {
            [key]: value,
            updatedDate: serverTimestamp()
          }); 
          resolve()
        } catch (error) {
          console.log("error updating org:",error )
          reject(error)
        }

      })
    },
    async saveCustomWords () {
      console.log("saving custom words:", this.org.customisations.localeOverrides)

      this.possibleOverrides.forEach(element => {

        this.org.customisations.localeOverrides[element.label] =
        (element.currentVal && element.currentVal.length) ?  element.currentVal : null

      });

      try {
        
        await this.udpateOrgData("customisations.localeOverrides", this.org.customisations.localeOverrides )

        localisation.refreshCustomLocales(this.org.customisations.localeOverrides)

        this.$toast.success(`Words updated!`)
      } catch (error) {
        console.log('err saving org:', error)
        this.$toast.error(`Something went wrong updating your logo`)
      }
    },
    async archiveOrg() {
      console.log("user wants to delete organisation")
      // we'll give it the archive:true flag

      try {

        await this.udpateOrgData("archived", true)

        console.log("deleted org")
        this.$toast.success(`Organisation deleted`)
        // clear the orgs
        this.$store.dispatch("getOrgs", this.user)
        // clear active org
        this.$store.dispatch("setActiveOrg")
        this.$router.push("/")
      } catch (error) {
        console.log('err saving org:', error)
        this.$toast.error(`Something went wrong deleting organisation`)
      }
    }
  }
}
